module.exports = __webpack_public_path__ + "img/xieer-ai.01b5eb29.png";